<template>
  <div class="w-full mt-20 md:px-2">
    <div class="w-full">
      <div class="flex justify-center items-center w-inherit pb-8">
        <div class="w-full mx-auto w-inherit pb-8">
          <div class="w-full text-right mb-4">
            <a
              class="text-green-7 hover:text-green-5 font-bold cursor-pointer px-2"
              @click="show.create = true"
            >Create An Emote</a>
          </div>

          <div class="flex flex-wrap justify-around mx-auto w-inherit pb-8">
            <emote-item v-for="emote in emotes" :key="emote.name" :emote="emote"></emote-item>
          </div>
        </div>
      </div>
    </div>

    <portal to="modal-portal">
      <emote-create-form v-if="show.create" @close="show.create = false" @success="createSuccess" />
    </portal>

    <portal to="breadcrumb-portal">
      <breadcrumbs>
        <router-link class="breadcrumb-link" :to="{name: 'channels.index'}">Home</router-link>
        <chevron-right-icon class="mx-1"></chevron-right-icon>
        <router-link class="breadcrumb-link" :to="{name: 'admin'}">Admin</router-link>
        <chevron-right-icon class="mx-1"></chevron-right-icon>
        <span class="breadcrumb-current">Emotes</span>
      </breadcrumbs>
    </portal>
  </div>
</template>

<script>
import EmoteCreateForm from "@/components/Forms/EmoteCreateForm"
import EmoteItem from "@/components/Items/EmoteItem"
import { mapActions, mapGetters } from "vuex"
import { ChevronRightIcon } from "vue-feather-icons"

export default {
  name: "Emotes",
  components: {
    EmoteCreateForm,
    EmoteItem,
    ChevronRightIcon
  },
  data() {
    return {
      loading: false,
      show: {
        create: false
      }
    }
  },
  computed: {
    ...mapGetters({
      emotes: "emotes/list"
    })
  },
  methods: {
    ...mapActions({
      fetch: "emotes/fetch"
    }),
    createSuccess() {
      this.show.create = false
      this.fetch()
    }
  }
}
</script>
